import { Stack, TextField } from '@mui/material';
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  themeColor: string;
  onChangeElement: (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => void;
};

const StyleSettingsForm: FunctionComponent<Props> = ({
  themeColor,
  onChangeElement,
}) => {
  const { t } = useTranslation();

  return (
    <Stack direction='column' spacing='30px'>
      <TextField
        id='outlined-basic'
        name='themeColor'
        label={t('theme_color')}
        variant='outlined'
        type='color'
        value={themeColor}
        onChange={onChangeElement}
      />
    </Stack>
  );
};

export default React.memo(StyleSettingsForm);
